export default "__VITE_ASSET__D205_gcQ__"